import { errorHandlerFacet } from "@ms/items-view-prefetch";
import { IFaceted } from "@ms/items-view";
import { LoggingService } from "@msteams/bridges-services-ts-logging";
import { matchAndScrubPii } from "@msteams/core-services-telemetry";
import { extractCorrelationId } from "@msteams/bridges-services-utilities-files";
import { bundleErrorStateManager } from "@msteams/bridges-services-files";
import { webpackChunkLoadErrorName } from "@msteams/bridges-models-files";
import { itemsViewErrorPrefix } from "../constants";

interface IItemsViewError extends Error {
  request: string;
  innerError?: IItemsViewError;
}

export function getErrorHandlerFacet(): IFaceted<
  (error: IItemsViewError) => void
> {
  return errorHandlerFacet.pack((error: IItemsViewError) => {
    const errorMessage =
      error && error.message
        ? extractCorrelationId(error.message) || matchAndScrubPii(error.message)
        : "Unknown error from items-view";
    LoggingService.logError(`${itemsViewErrorPrefix}${errorMessage}`);

    // to catch spaddondeferred chunk
    if (
      error &&
      error.innerError &&
      isWebpackChunkLoadFailure(error.innerError)
    ) {
      bundleErrorStateManager.triggerBundleErrorCallback(
        error.innerError.request
      );
      // to catch deferredcomponents chunk
    } else if (error && isWebpackChunkLoadFailure(error)) {
      bundleErrorStateManager.triggerBundleErrorCallback(error.request);
    }
  });
}

function isWebpackChunkLoadFailure(error: IItemsViewError): boolean {
  return error.name === webpackChunkLoadErrorName;
}
